import { Table } from "reactstrap";
import { H4, Image, LI, UL } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";

const InvoiceHead = () => {
  return (
    <tr>
      <td className="p-0">
        <Table borderless style={{ width: "100%" }}>
          <tbody>
            <tr style={{ padding: "28px 0 5px", display: "flex", justifyContent: "space-between" }}>
              <td className="p-0">
                <H4 style={{ fontSize: 42, fontWeight: 600, color: "#2A5699", margin: 0 }}>INVOICE</H4>
                <UL className="simple-list" style={{ listStyle: "none", display: "flex", gap: 15, padding: 0, margin: "20px 0" }}>
                  <LI className="invoice-text">
                    <span style={{ fontSize: 18, fontWeight: 600, opacity: "0.8" }}>Invoice to :</span>
                  </LI>
                  <LI className="invoice-text">
                    <span style={{ fontWeight: 600, fontSize: 18, display: "block", color: "#2A5699", marginBottom: 8 }}>Brooklyn Simmons</span>
                    <span style={{ width: "75%", display: "block", lineHeight: "1.5", fontSize: 18, fontWeight: 400, opacity: "0.8" }}>2972 Westheimer Rd. Santa Ana, Illinois 85486 </span>
                    <span style={{ lineHeight: "1.9", fontSize: 18, fontWeight: 400, opacity: "0.8", display: "block" }}>Phone : (219) 555-0114</span>
                    <span style={{ lineHeight: "1.7", fontSize: 18, fontWeight: 400, opacity: "0.8", display: "block" }}>Email : yourmail@themesforest.com</span>
                    <span style={{ lineHeight: "1.7", fontSize: 18, fontWeight: 400, opacity: "0.8", display: "block" }}>Website: www.websites.com</span>
                  </LI>
                </UL>
              </td>
              <td className="p-0">
                <Image className="img-fluid for-light" src={dynamicImage(`logo/logo-1.png`)} alt="looginpage" />
                <Image className="img-fluid for-dark" src={dynamicImage(`logo/logo.png`)} alt="looginpage" />
                <span style={{ display: "block", lineHeight: "1.5", fontSize: 18, fontWeight: 400, opacity: "0.8" }}>2118 Thornridge Cir. Syracuse, Connecticut 35624, United State</span>
                <span style={{ display: "block", lineHeight: "1.5", fontSize: 18, fontWeight: 400, opacity: "0.8" }}>Phone : (239) 555-0108</span>
                <span style={{ display: "block", lineHeight: "1.5", fontSize: 18, fontWeight: 400, opacity: "0.8" }}>Email : berlin@themesforest.com</span>
                <span style={{ display: "block", lineHeight: "1.5", fontSize: 18, fontWeight: 400, opacity: "0.8" }}>Website: www.Berlinthemes.com</span>
              </td>
            </tr>
          </tbody>
        </Table>
      </td>
    </tr>
  );
};

export default InvoiceHead;
